// extracted by mini-css-extract-plugin
module.exports = {"item":"HVsqz","boxImage":"l57jl","placeholder":"LD1rn","img":"kW7iz"};